import Vue from 'vue'
import moment from 'moment'

const conf = require('../../config/index.js')
const env = process.env.NODE_ENV || 'alpha'

const state = {
  _env: conf[env],
  age: 1,
  count: 0,
  is_amlo_rm: {
    status: false,
    title_name: {
      description: null,
    },
    first_name: null,
    last_name: null,
  },
  count_confirm: 0,
  count_methods_pay: 0,
  titles: [],
  get_hospital: null,
  payer_national: null,
  payer_relation: {
    id: null,
  },
}
const mutations = {
  INCREMENT(state, payload) {
    state.count += payload
  },
  DE_INCREMENT(state, payload) {
    state.count -= payload
  },
  PLUS_COUNT_CONFIRM(state) {
    state.count_confirm += 1
  },
  PLUS_METHODS_PAY() {
    state.count_methods_pay += 1
  },
  ALL_TITLE(state, payload) {
    state.titles = payload
  },
  SET_AGE(state, payload) {
    state.age = payload
  },
  AMLO_RM(state, payload) {
    state.is_amlo_rm = payload
  },
  GET_HOSPITAL(state, payload) {
    state.get_hospital = payload
  },
  PAYER_NATIONAL(state, payload) {
    state.payer_national = payload
  },
  PAYER_RELATION(state, payload) {
    state.payer_relation = payload
  },
}
const actions = {
  increment: ({ commit }, amount) => commit('INCREMENT', amount),
  deincrement: ({ commit }, amount) => commit('DE_INCREMENT', amount),

  plusCountConfirm: ({ commit }) => commit('PLUS_COUNT_CONFIRM'),
  plusMethodsPay: ({ commit }) => commit('PLUS_METHODS_PAY'),
  save_age({ commit }, age) {
    commit('SET_AGE', age)
  },
  save_peryer_national({ commit }, payer_national) {
    commit('PAYER_NATIONAL', payer_national)
  },
  save_peryer_relation({ commit }, payer_relation) {
    commit('PAYER_RELATION', payer_relation)
  },

  //[API: get data ]
  apiGetHosptal({ commit }, tambonId) {
    let res
    Vue.http
      .get(conf[env].VUE_APP_PATH_API + 'hospitals/' + tambonId, {
        headers: {
          Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
          'x-auth-from': this._vm.$session.get('chili').auth_from,
        },
      })
      .then(
        response => {
          res = response.body
          //console.log("HOSPITAL", res);
          if (res.statusCode == 200) {
            commit('GET_HOSPITAL', res.result.hospitals)
          } else {
            commit('GET_HOSPITAL', null)
          }
        },
        response => {
          let res = response.body
          if (res.statusCode == 400) {
            commit('GET_HOSPITAL', null)
          }
          commit('GET_HOSPITAL', null)
        },
      )
  },
  apiGetTitle({ commit }) {
    return new Promise((resolve, reject) => {
      if (this.getTitles == undefined) {
        const CALL_API = conf[env].VUE_APP_PATH_API
        let res
        Vue.http
          .get(`${CALL_API}title`, {
            headers: {
              Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
              'x-auth-from': this._vm.$session.get('chili').auth_from,
            },
          })
          .then(
            response => {
              res = response.body
              if (res.statusCode == 401) {
                window.location.href = conf[env].VUE_APP_LOCATION
              }
              if (res.statusCode == 200) {
                commit('ALL_TITLE', res.result.title)
              } else {
                commit('ALL_TITLE', null)
              }
            },
            response => {},
          )
      }
    })
  },
  setAmloRm({ commit }, data) {
    commit('AMLO_RM', data)
  },
}

const getters = {
  getCounter: state => state,
  getAmloRm: state => state.is_amlo_rm,
  resHospital: state => state.get_hospital,
  respayerNational: state => state.payer_national,
  respayerRelation: state => state.payer_relation,
  getAge: state => state.age,
  getCountConfirm: state => state.count_confirm,
  getCountMethodsPay: state => state.count_methods_pay,
  getCheckFromPaymethod: state => state.check_from_paymethod,
  getTitles: state => state.titles,
  env: state => state._env,
  findIdTitle: (state, getters, dispatch) => str => {
    return state.titles.find(function (element) {
      if (element.description === str) return element
    })
  },
  statusPolicy: state => status_id => {
    let status_policy = null

    switch (status_id) {
      case 1:
        status_policy = 'รอชำระเงิน'
        break
      case 2:
        status_policy = 'ออกกรมธรรม์'
        break
      case 3:
        status_policy = 'เลยกำหนดชำระเงิน'
        break
      case 4:
        status_policy = 'ยกเลิกใบคำขอ'
        //status_policy = "ยกเลิกกรมธรรม์";
        break
      case 5:
        status_policy = 'ขาดเอกสาร'
        break
      case 6:
        status_policy = 'ยกเลิกกรมธรรม์'
        break
      default:
      // code block
    }

    return status_policy
  },
  showTimestamp: state => timestamp => {
    if (timestamp != null) {
      return moment(timestamp).format('DD/MM/YYYY HH:mm')
    }
  },
  calculateAge: state => birthday => {
    let today = moment()
    let bd = moment(birthday)
    let diff_years = today.diff(bd, 'years')
    let diff_months = today.diff(bd, 'months') % 12
    let str_age = diff_years >= 1 ? diff_years + 'ปี ' : diff_months + 'เดือน'

    return {
      age: diff_years,
      str_age: str_age,
    }
  },
  sortCoverage: state => arrCoverage => {
    let str_coverage = 'IPD+PA'
    let number
    let temp_coverage = []
    arrCoverage.map(function(value, key) {
      if (key != 0 && value != 'OPD') {
        switch (value) {
          case 'OPD(Standard)':
            number = 2
            break
          case 'OPD(Deluxe)':
            number = 2
            break
          case 'HIB':
            number = 3
            break
          case 'Cancer':
            number = 4
            break
          case 'CI':
            number = 5
            break
        }
        temp_coverage[number] = value
      }
    })
    //set coverage call api
    temp_coverage.map(function(value, key) {
      if (key != 0) {
        str_coverage += '+' + value
      }
    })

    return str_coverage
  },
  dateToday: state => () => {
    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    yyyy = yyyy + parseInt(543)

    today = dd + '/' + mm + '/' + yyyy
    return today
  },
  dateToday2: state => () => {
    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    yyyy = yyyy + parseInt(543)

    let month_th
    switch (mm) {
      case '01':
        month_th = 'มกราคม'
        break
      case '02':
        month_th = 'กุมภาพันธ์'
        break
      case '03':
        month_th = 'มีนาคม'
        break
      case '04':
        month_th = 'เมษายน'
        break
      case '05':
        month_th = 'พฤษภาคม'
        break
      case '06':
        month_th = 'มิถุนายน'
        break
      case '07':
        month_th = 'กรกฎาคม'
        break
      case '08':
        month_th = 'สิงหาคม'
        break
      case '09':
        month_th = 'กันยายน'
        break
      case '10':
        month_th = 'ตุลาคม'
        break
      case '11':
        month_th = 'พฤศจิกายน'
        break
      case '12':
        month_th = 'ธันวาคม'
        break
    }

    today = {
      date: dd,
      month: month_th,
      year: yyyy,
    }
    return today
  },
  checkScoped: state => scoped => {
    switch (scoped) {
      case 'SCOPE001':
        scoped = 'all'
        break
      case 'SCOPE002':
        scoped = 'sale'
        break
      case 'SCOPE003':
        scoped = 'manager_branch'
        break
      case 'SCOPE004':
        scoped = 'manager_district'
        break
      case 'SCOPE005':
        scoped = 'sale_admin'
        break
    }
    return scoped
  },
  numberWithCommas: state => x => {
    if (x != null || x != '') {
      x = parseInt(x)
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    } else {
      return true
    }
  },
  formatDateTh: state => date => {
    let dateTh = date.split('-')
    let yearTh = parseInt(dateTh[0]) + 543
    let res = {
      human: dateTh[2] + '/' + dateTh[1] + '/' + yearTh,
      origin: date,
    }
    return res
  },
  formatCoverage: state => coverage => {
    let res = ''
    let temp = 'IPD+PA'
    let cover = null
    if (coverage != null) {
      coverage = coverage.split('+')
      coverage.map(function(value, key) {
        if (key != 0 && key != 1) {
          if (value == 'OPD(Standard)' || value == 'OPD(Deluxe)') {
            cover = 'OPD'
          } else {
            cover = value
          }
          res += ',' + cover
        }
      })
      res = temp + res
    }
    return res
  },
  formatDockDateTh: state => date => {
    let res = null
    if (date != null) {
      let dateTh = date.split('-')
      let yearTh = parseInt(dateTh[0]) + 543
      res = dateTh[2] + '/' + dateTh[1] + '/' + yearTh
    }
    return res
  },
  formatDockDateTimeTh: state => date => {
    let res = null
    if (date != null) {
      date = moment(date).format('YYYY/MM/DD HH:mm')
      let temp = date.split(' ')
      let temp_date = temp[0]
      let temp_time = temp[1]
      temp_date = temp_date.split('/')
      let yearTh = parseInt(temp_date[0]) + 543
      res = temp_date[2] + '/' + temp_date[1] + '/' + yearTh + ' ' + temp_time
      //console.log('formatDockDateTh',res)
    }
    return res
  },
  formatDockDateEn: state => date => {
    let res = null
    if (date != null) {
      let dateTh = date.split('-')
      res = dateTh[2] + '/' + dateTh[1] + '/' + dateTh[0]
    }
    return res
  },
  formatDockDateRm: state => date => {
    let dateTh = date.split('-')
    let year = parseInt(dateTh[0]) + 543
    let res = dateTh[2] + '' + dateTh[1] + '' + year
    //format is :10072562
    //console.log("date Rm", res);
    return res
  },
  formatTelMoble: state => tel => {
    if (tel != null) {
      tel = tel.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, '$1-$2-$3')
    }
    return tel
  },
  formatTelHome: state => tel => {
    if (tel != null) {
      tel = tel.replace(/^\(?(\d{1,2})\)?[-. ]?(\d{3,4})[-. ]?([0-9]{4})$/, '$1-$2-$3')
    }
    return tel
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
